import { defineComponent as l, ref as d, computed as p, openBlock as s, createElementBlock as c, normalizeClass as x, toDisplayString as a } from "vue";
import { _ as u } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var e = /* @__PURE__ */ ((t) => (t.Outlined = "outlined", t.OutlinedBold = "outlined-bold", t.Filled = "filled", t.FilledBold = "filled-bold", t.Inherit = "inherit", t))(e || {}), o = /* @__PURE__ */ ((t) => (t.XL = "xl", t.L = "l", t.M = "m", t.Inherit = "inherit", t))(o || {});
const m = [
  // Layout
  "layout-inline-row justify-center"
], h = {
  [e.Outlined]: [
    // Iconography
    "iconography-outlined"
  ],
  [e.OutlinedBold]: [
    // Iconography
    "iconography-outlined-bold"
  ],
  [e.Filled]: [
    // Iconography
    "iconography-filled"
  ],
  [e.FilledBold]: [
    // Iconography
    "iconography-filled-bold"
  ],
  [e.Inherit]: [
    // Iconography
    "iconography-inherit"
  ]
}, f = {
  [o.XL]: [
    // Box
    "w-[28px] md:w-[24px]",
    "h-[28px] md:h-[24px]",
    // Typography
    "text-[28px] md:text-[24px]"
  ],
  [o.L]: [
    // Box
    "w-[24px] md:w-[20px]",
    "h-[24px] md:h-[20px]",
    // Typography
    "text-[24px] md:text-[20px]"
  ],
  [o.M]: [
    // Box
    "w-[20px] md:w-[16px]",
    "h-[20px] md:h-[16px]",
    // Typography
    "text-[20px] md:text-[16px]"
  ],
  [o.Inherit]: [
    // Typography
    "text-inherit"
  ]
}, y = l({
  name: "OrIcon",
  props: {
    icon: {
      type: String,
      required: !0
    },
    variant: {
      type: String,
      default: () => e.Outlined
    },
    size: {
      type: String,
      default: () => o.M
    }
  },
  emits: [
    "click"
  ],
  expose: [
    "root"
  ],
  setup(t) {
    const i = d(), n = p(() => [
      "or-icon-v3",
      ...m,
      ...h[t.variant],
      ...f[t.size],
      ...t.icon.startsWith("or_") ? ["iconography-onereach"] : []
    ]);
    return {
      root: i,
      rootStyles: n
    };
  }
});
function g(t, i, n, O, w, v) {
  return s(), c("div", {
    ref: "root",
    class: x(t.rootStyles),
    onClick: i[0] || (i[0] = (r) => t.$emit("click", r))
  }, a(t.icon), 3);
}
const _ = /* @__PURE__ */ u(y, [["render", g]]);
export {
  e as I,
  _ as O,
  o as a
};
//# sourceMappingURL=OrIcon-k8cyvh-D.mjs.map
